var React = require('react');

function NewOrder (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M208,97.37V96A80,80,0,0,0,48,96v1.37A24,24,0,0,0,56,144h3.29l54.82,95.94a16,16,0,0,0,27.78,0L196.71,144H200a24,24,0,0,0,8-46.63ZM77.71,144H97.07l40.61,71.06L128,232Zm57.08,0,21.75,38.06-9.65,16.88L115.5,144Zm31,21.94L153.21,144h25.08ZM200,128H56a8,8,0,0,1,0-16,8,8,0,0,0,8-8V96a64,64,0,0,1,128,0v8a8,8,0,0,0,8,8,8,8,0,0,1,0,16Z"}));
}

NewOrder.defaultProps = {"width":"32","height":"32","fill":"#000000","viewBox":"0 0 256 256"};

module.exports = NewOrder;

NewOrder.default = NewOrder;
